import { render } from "./tpl_page.vue?vue&type=template&id=734e189a&scoped=true"
import script from "./tpl_page.vue?vue&type=script&lang=js"
export * from "./tpl_page.vue?vue&type=script&lang=js"

import "./tpl_page.vue?vue&type=style&index=0&id=734e189a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734e189a"],['__file',"src/views/dragger/template/tpl_page.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "734e189a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('734e189a', __exports__)) {
    console.log('reload')
    api.reload('734e189a', __exports__)
  }
  
  module.hot.accept("./tpl_page.vue?vue&type=template&id=734e189a&scoped=true", () => {
    console.log('re-render')
    api.rerender('734e189a', render)
  })

}


export default __exports__